import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Bath: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 46 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.1155 31.0604C37.9155 39.0604 18.2822 37.3937 9.11549 35.5604C1.61549 33.3937 -8.28451 26.2604 12.1155 15.0604C32.5155 3.8604 39.9488 6.72706 41.1155 9.5604C43.9488 13.3937 48.3155 23.0604 43.1155 31.0604Z"
        fill="#0BA95E"
        fillOpacity="0.2"
      />
      <path
        d="M13.6634 28.6334C13.3941 29.0373 13.5032 29.583 13.9071 29.8523C14.057 29.9522 14.2263 30 14.3938 30C14.6778 30 14.9566 29.8625 15.1259 29.6084L15.7958 28.6037C15.2535 28.3657 14.7369 28.0798 14.2519 27.7506L13.6634 28.6334Z"
        fill="#1B3029"
      />
      <path
        d="M35.6313 27.7506C35.1463 28.0798 34.6297 28.3657 34.0874 28.6037L34.7572 29.6084C34.9266 29.8625 35.2053 30 35.4893 30C35.6568 30 35.8262 29.9522 35.9761 29.8523C36.38 29.583 36.4891 29.0373 36.2198 28.6334L35.6313 27.7506Z"
        fill="#1B3029"
      />
      <path
        d="M11.7578 17.0005V19.7461C11.7578 24.1077 15.3063 27.6562 19.668 27.6562H30.2148C34.5765 27.6562 38.125 24.1077 38.125 19.7461V19.2343H23.6021C19.5162 19.2343 15.5389 18.483 11.7578 17.0005Z"
        fill="#1B3029"
      />
      <path
        d="M14.6875 10.3587V3.22266C14.6875 2.41494 15.3446 1.75781 16.1523 1.75781H17.3242C18.1319 1.75781 18.7891 2.41494 18.7891 3.22266V3.63967C17.4304 4.03113 16.4453 5.30625 16.4453 6.78721V7.03125C16.4453 7.51664 16.8388 7.91016 17.3242 7.91016H22.0117C22.4971 7.91016 22.8906 7.51664 22.8906 7.03125V6.73828C22.8906 5.266 21.8979 4.02187 20.5469 3.63826V3.22266C20.5469 1.44568 19.1012 0 17.3242 0H16.1523C14.3754 0 12.9297 1.44568 12.9297 3.22266V9.65297C13.0681 9.69551 13.2047 9.74549 13.3388 9.80496C13.7847 10.0031 14.2344 10.1874 14.6875 10.3587Z"
        fill="#1B3029"
      />
      <path
        d="M38.0151 13.7412H23.6022C19.7958 13.7412 16.1036 12.9575 12.6267 11.4121C11.6825 10.9939 10.5803 11.4176 10.1614 12.36C9.74256 13.3023 10.1669 14.4063 11.1093 14.8252C15.0671 16.5847 19.2699 17.4765 23.6023 17.4765H38.0152C39.0469 17.4765 39.8829 16.6406 39.8829 15.6089C39.8828 14.5771 39.0468 13.7412 38.0151 13.7412Z"
        fill="#1B3029"
      />
    </svg>
  )
})

Bath.displayName = 'Bath'
